import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Header from "../Component/Header";
import Footer from "../Component/Footer";
import Sidebar from "../Component/Sidebar";

const Layout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("USER_TOKEN");
    if (!token) navigate("/");
  }, [navigate]);
  return (
    <div className="hk-wrapper" data-layout="vertical" data-layout-style="default" data-menu="light" data-footer="simple">
      <Header />
      <Sidebar />
      <Outlet />
    </div>
  );
};

export default Layout;
